import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReactComponent } from './simple-icons-react.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReactComponent ],
    exports:      [ SimpleIconsReactComponent ],
    bootstrap:    []
})
export class SimpleIconsReactModule {}
